import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import MoreVertIcon from '@mui/icons-material/MoreVert';

const MoreVert = ({ size="small", ...props }) => <IconButton aria-label="more-vertical" size={size} {...props}>
    <MoreVertIcon fontSize="inherit" />
</IconButton>

const Delete = ({ size="small", ...props }) => <IconButton aria-label="delete" size={size} {...props}>
    <DeleteIcon fontSize="inherit" />
</IconButton>

export { MoreVert, Delete }